import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Flame, Truck, Clock } from "lucide-react";
import { IMG, restaurant } from "../mock/menuData";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="relative brick-bg overflow-hidden pt-28 md:pt-36 pb-16">
      {/* glow accents */}
      <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-pink/20 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-gold/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
        <div className="animate-float-up">
          <span className="inline-flex items-center gap-2 bg-white text-black text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full border-2 border-pink">
            <Flame size={14} className="text-pink" /> Halal Food · 7j/7 non stop
          </span>

          <h1 className="mt-5 leading-none">
            <span className="block font-script text-5xl md:text-7xl text-white">M.<span className="text-pink">Plaisir</span></span>
            <span className="block font-display text-2xl md:text-4xl text-gold uppercase mt-2">By Dragon Food</span>
          </h1>

          <p className="mt-4 text-lg md:text-xl text-white/80 font-semibold">
            {restaurant.subtitle}
          </p>
          <p className="mt-2 text-white/60 max-w-md">
            Sandwichs, burgers, tacos, hummers & buckets à partager. Des portions généreuses, des ingrédients frais, 100% halal à Marseille.
          </p>

          <div className="mt-7 flex flex-wrap gap-4">
            <button
              onClick={() => navigate("/carte")}
              className="group bg-pink text-white font-display text-lg uppercase px-7 py-3 rounded-full btn-shine flex items-center gap-2"
            >
              Commander <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => navigate("/carte")}
              className="bg-transparent border-2 border-white/30 text-white font-display text-lg uppercase px-7 py-3 rounded-full hover:border-gold hover:text-gold transition-colors"
            >
              Voir la carte
            </button>
          </div>

          <div className="mt-8 flex flex-wrap gap-6 text-sm">
            <div className="flex items-center gap-2 text-white/80"><Truck size={18} className="text-gold" /> Livraison gratuite dès {restaurant.freeDeliveryFrom}€</div>
            <div className="flex items-center gap-2 text-white/80"><Clock size={18} className="text-gold" /> 11h – 02h (03h ven/sam)</div>
          </div>
        </div>

        <div className="relative animate-float-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative rounded-3xl overflow-hidden border-4 border-pink shadow-2xl">
            <img src={IMG.burger1} alt="Burger signature M.Plaisir" className="w-full h-[360px] md:h-[460px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-5 -left-5 bg-gold text-black rounded-2xl px-5 py-3 shadow-xl rotate-[-6deg]">
            <p className="font-display text-xl uppercase leading-none">Nouveau</p>
            <p className="font-body text-xs font-semibold">propriétaire</p>
          </div>
          <img src={IMG.tacos1} alt="Tacos" className="hidden md:block absolute -top-6 -right-6 w-32 h-32 object-cover rounded-2xl border-4 border-white shadow-xl rotate-6" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
